import { render, staticRenderFns } from "./ButtonDropDownVariants.vue?vue&type=template&id=6dd540dc&"
import script from "./ButtonDropDownVariants.vue?vue&type=script&lang=js&"
export * from "./ButtonDropDownVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports